import {
  REVIEW_SET_INBOX_ICON,
  REVIEW_SET_PLAY_ICON,
  REVIEW_SET_SAMPLE_ICON,
  REVIEW_STARS_ICON,
} from 'constants/reviewSets';
import React from 'react';

type ReviewSetDefaultItemProps = {
  type: 'inbox' | 'sample';
  leftTitle: string;
  leftText: string;
  active?: boolean;
};

const ReviewSetDefaultItem: React.FC<ReviewSetDefaultItemProps> = ({
  type,
  leftTitle,
  leftText,
  active = false,
}) => {
  const renderRightSection = (): JSX.Element | null =>
    active ? (
      <div className="flex flex-row items-center gap-6 h-full p-2">
        <button type="button" className="button--task-button" data-testid="task-button">
          <div className="w-5">{REVIEW_SET_PLAY_ICON()}</div>
          <div>Start</div>
        </button>
      </div>
    ) : null;

  const renderLeftSection = (): JSX.Element => (
    <div
      className={`flex flex-row items-center gap-4 flex-1 h-full pl-6 pr-4 py-6 ${
        active ? 'bg-litlingo-secondary-80 bg-opacity-50' : 'bg-litlingo-gray-2 bg-opacity-20'
      }`}
    >
      <div className="flex w-12.5">
        {type === 'inbox' ? REVIEW_SET_INBOX_ICON : REVIEW_SET_SAMPLE_ICON}
      </div>
      <div className="flex flex-col justify-center gap-2 h-full">
        <div className="flex text-heading-3">{leftTitle}</div>
        <div className="flex text-body">{leftText}</div>
      </div>
    </div>
  );

  return (
    <div
      className={`flex flex-row w-full min-h-26 bg-white border-l-16 border-2 rounded focus:outline-none ${
        active ? 'border-litlingo-secondary-80' : 'border-litlingo-gray-3'
      }`}
      data-testid="review-set"
    >
      {renderLeftSection()}
      {renderRightSection()}
    </div>
  );
};

const EmptyReviewList: React.FC = () => (
  <div className="w-full flex flex-col gap-8">
    <div className="w-full flex flex-col py-8 px-14 border-8 border-litlingo-primary-100 rounded">
      <div className="h-full w-full flex flex-col gap-4">
        <div className="self-center">{REVIEW_STARS_ICON}</div>
        <div className="h-full w-full flex flex-col gap-1">
          <span className="text-heading-2 text-center">No Assigned Streams to Review</span>
          <p>
            This section is where your assignments will live. You’ll see them populated here as soon
            as your Review Manager assigns them. The cards below are what you can expect when you
            have assignments.
          </p>
        </div>
      </div>
    </div>
    <div className="w-full flex flex-col gap-4">
      <ReviewSetDefaultItem
        type="inbox"
        leftTitle="Open Assignment Example"
        leftText="Number of messages in assignment"
        active
      />
      <ReviewSetDefaultItem
        type="inbox"
        leftTitle="Completed Assignment Example"
        leftText="Assignment completed"
      />
    </div>
  </div>
);

export default EmptyReviewList;
